// src/components/MentorProfile.js
import React from "react";
import "./MentorProfile.css";

const MentorProfile = () => {
  return (
    <div className="instructor-profile">
      <h2 className="titleu">Meet Our Founder</h2>
      <div className="instructor-info">
        <div className="image-container">
          <img
            src="/anup.jpg"
            alt="Anup Batra"
          />
        </div>
        <div className="details">
          <div className="highlightso">
            <div className="highlightp"> Managed over 10crs in Ad spend</div>
            <div className="highlightp"> Shared ideas and insights with Google as a premium partner</div>
            <div className="highlightp">
            Clients have gained more than 3000 Crore in extra revenue
            </div>
            <div className="highlightp"> Trained over 10,000 Students
            </div>
          </div>
          <p className="description">
          Right from his first exposure on the internet, Anup has been passionate about helping individuals and businesses to leverage it's power for branding, marketing and sales. He has won numerous awards from his clients in Australia, US and India.  Treating his clients like partners, Anup goes an extra mile for them. He is known to be both innovative and revolutionary. 
            <br />
            <br />
            Teaching is his passion and he is the Head Trainer of our certificate courses.
Anup is also a member of Forbes Business Council and shares his insights in a Global community.

Anup's Vision is to make India a market leader in Digital Marketing and AI.
          </p>
        </div>
      </div>
      {/* <div className="call-to-action">
        <h3>START LEARNING FROM ANUP NOW!</h3>
        <button className="ctat-button">✔️ Enroll Now for ₹399</button>
      </div> */}
    </div>
  );
};

export default MentorProfile;
